import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { CmsConfig, PageMetaModule, provideConfig, UrlModule } from '@spartacus/core'
import { IconModule } from '@spartacus/storefront'
import { EbBreadcrumbComponent } from './eb-breadcrumb.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    PageMetaModule,
    IconModule,
    UrlModule,
    EbBreadcrumbComponent
  ],
  providers: [
    provideConfig({
      cmsComponents: {
        BreadcrumbComponent: {
          component: EbBreadcrumbComponent
        }
      }
    } as CmsConfig)
  ],
  exports: [EbBreadcrumbComponent]
})
export class EbBreadcrumbModule {}
